import { render } from "./CreateAgenda.vue?vue&type=template&id=053db74a"
import script from "./CreateAgenda.vue?vue&type=script&lang=js"
export * from "./CreateAgenda.vue?vue&type=script&lang=js"

import "./CreateAgenda.vue?vue&type=style&index=0&id=053db74a&lang=scss"

import exportComponent from "C:\\Users\\john doe\\Documents\\Venice\\vnc\\AgendaBuilder\\agenda\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__